var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55 14.25H10.45V10.45H14.25V8.55H10.45V4.75H8.55V8.55H4.75V10.45H8.55V14.25ZM9.5 19C8.18583 19 6.95083 18.7506 5.795 18.2519C4.63917 17.7531 3.63375 17.0763 2.77875 16.2213C1.92375 15.3663 1.24688 14.3608 0.748125 13.205C0.249375 12.0492 0 10.8142 0 9.5C0 8.18583 0.249375 6.95083 0.748125 5.795C1.24688 4.63917 1.92375 3.63375 2.77875 2.77875C3.63375 1.92375 4.63917 1.24688 5.795 0.748125C6.95083 0.249375 8.18583 0 9.5 0C10.8142 0 12.0492 0.249375 13.205 0.748125C14.3608 1.24688 15.3663 1.92375 16.2213 2.77875C17.0763 3.63375 17.7531 4.63917 18.2519 5.795C18.7506 6.95083 19 8.18583 19 9.5C19 10.8142 18.7506 12.0492 18.2519 13.205C17.7531 14.3608 17.0763 15.3663 16.2213 16.2213C15.3663 17.0763 14.3608 17.7531 13.205 18.2519C12.0492 18.7506 10.8142 19 9.5 19Z",
    fill: "url(#paint0_linear_2372_1983)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2372_1983",
    x1: 9.5,
    y1: 0,
    x2: 9.5,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E8BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircledIcon);
export default __webpack_public_path__ + "static/media/Add_Circled_Icon.44efca117e07b7ebe3bd03e05c7ce11e.svg";
export { ForwardRef as ReactComponent };